import { computed } from 'vue'
import { useStoreCompat } from './useStoreCompat'

export function useUserAccess() {
  const store = useStoreCompat()
  const user = computed(() => store.state.user)

  /**
   * Verifica si el usuario tiene un permiso específico.
   * @param {String} tipoPermiso
   * @returns {Boolean}
   */
  function tienePermisos(tipoPermiso) {
    if (!user.value?.userdata?.permisos) return false

    if (tipoPermiso === 'PermisoAdministradorDelSistema') {
      return user.value.userdata.permisos.some(
        (e) => e.PermisousuarioID === 'PermisoSuperUsuario'
      )
    }

    return user.value.userdata.permisos.some(
      (e) => e.PermisousuarioID === tipoPermiso
    )
  }

  /**
   * Verifica si el usuario es del tipo indicado.
   * @param {String[] | String} tipoUsuario
   * @returns {Boolean}
   */
  function esTipoUsuario(tipoUsuario) {
    const actual = user.value?.userdata?.tipoUsuario
    if (!actual) return false

    if (Array.isArray(tipoUsuario)) {
      return tipoUsuario.includes(actual)
    }

    return actual === tipoUsuario
  }

  return {
    tienePermisos,
    esTipoUsuario,
    user
  }
}
